export default [
    {
        path: "/pages/panel/panel",
        name: "center-panel",
        meta: {
            icon: "el-icon-ali-dingyuehao", title: "首页概览",
        },
        component: () => import("../pages/panel/panel.vue"),
    },
    // {
    //     path: "/pages/category/category",
    //     name: "category",
    //     meta: {
    //         icon: "el-icon-eleme", title: "分类管理",
    //     },
    //     component: () => import("@/pages/category/category.vue")
    // },
    // {
    //     path: "/pages/resource/resource",
    //     name: "resource",
    //     meta: {
    //         icon: "el-icon-eleme", title: "资源管理",
    //     },
    //     component: () => import("./empty.js"),
    //     children: [
    //         {
    //             path: "/pages/resource/videos",
    //             name: "resource-videos",
    //             meta: {
    //                 title: "视频",
    //             },
    //             component: () => import("@/pages/resource/videos.vue")
    //         },
    //         {
    //             path: "/pages/resource/images",
    //             name: "resource-images",
    //             meta: {
    //                 title: "图片",
    //             },
    //             component: () => import("@/pages/resource/images.vue")
    //         },
    //         {
    //             path: "/pages/resource/courseware",
    //             name: "resource-courseware",
    //             meta: {
    //                 title: "课件",
    //             },
    //             component: () => import("@/pages/resource/courseware.vue")
    //         },
    //     ]
    // },

    // {
    //     path: "/pages/course/course",
    //     name: "course",
    //     meta: {
    //         icon: "el-icon-eleme", title: "课程中心",
    //     },
    //     component: () => import("./empty.js"),
    //     children: [
    //         {
    //             path: "/pages/course/online",
    //             name: "course-online",
    //             meta: {
    //                 title: "线上课程",
    //             },
    //             component: () => import("@/pages/course/online.vue")
    //         },
    //         {
    //             path: "/pages/course/live",
    //             name: "course-live",
    //             meta: {
    //                 title: "直播课程",
    //             },
    //             component: () => import("@/pages/course/live.vue")
    //         },
    //     ]
    // },

    {
        path: "/pages/student/index",
        name: "student",
        meta: {
            icon: "el-icon-eleme", title: "学员管理",
        },
        component: () => import("./empty.js"),
        children: [
            {
                path: "/pages/student/student",
                name: "student-videos",
                meta: {
                    title: "学员管理",
                },
                component: () => import("@/pages/student/student.vue")
            },
            // {
            //     path: "/pages/student/group",
            //     name: "student-group",
            //     meta: {
            //         title: "部门管理",
            //     },
            //     component: () => import("@/pages/student/group.vue")
            // },
        ]

    },

    {
        path: "/pages/examination/index",
        name: "examination",
        meta: {
            icon: "el-icon-document", title: "考试管理",
        },
        component: () => import("./empty.js"),
        children: [
            {
                path: "/pages/examination/question",
                name: "examination-question",
                meta: {
                    title: "试题管理",
                },
                component: () => import("@/pages/examination/question.vue")
            },
            {
                path: "/pages/examination/paper",
                name: "examination-paper",
                meta: {
                    title: "试卷管理",
                },
                component: () => import("@/pages/examination/paper.vue")
            },
            {
                path: "/pages/examination/test",
                name: "examination-test",
                meta: {
                    title: "测验管理",
                },
                component: () => import("@/pages/examination/test.vue")
            },
            {
                path: "/pages/examination/marking",
                name: "examination-marking",
                hidden:true,
                meta: {
                    title: "批改试卷"
                },
                component: () => import("@/pages/examination/marking.vue")
            },
        ]

    },
    // {
    //     path: "/pages/setting/setting",
    //     name: "setting",
    //     meta: {
    //         icon: "el-icon-eleme", title: "系统设置",
    //     },
    //     component: () => import("./empty.js"),
    //     children: [
    //         {
    //             path: "/pages/setting/config",
    //             name: "setting-config",
    //             meta: {
    //                 title: "系统配置",
    //             },
    //             component: () => import("@/pages/setting/config.vue")
    //         },
    //         {
    //             path: "/pages/setting/admin",
    //             name: "setting-admin",
    //             meta: {
    //                 title: "管理人员",
    //             },
    //             component: () => import("@/pages/setting/admin.vue")
    //         },
    //         {
    //             path: "/pages/setting/log",
    //             name: "setting-log",
    //             meta: {
    //                 title: "管理日志",
    //             },
    //             component: () => import("@/pages/setting/log.vue")
    //         },
    //     ]
    // },
]
